import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VehicleProfile, Vehicle } from '../models/common-data-types';
import { CreateVehicleRequest } from '../models/request-data-types';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService {

  constructor(private http: HttpClient) {}

  getVehicles(): Observable<Vehicle[]> {
    return this.http.get<Vehicle[]>(`/selfcare/vehicles`);
  }

  deleteVehicle(vehicleId: string): any{
    return this.http.delete(`/selfcare/vehicles/${vehicleId}`);
  }

  getQuotableVehicles(): Observable<Vehicle[]> {
    return this.http.get<Vehicle[]>(`/selfcare/motor-cover-options/quotable-vehicles`);
  }

  addVehicle(vehicle: CreateVehicleRequest): Observable<Vehicle> {
    return this.http.post<Vehicle>(`/selfcare/vehicles`, vehicle);
  }

  getVehicleProfile(vehicleId: string): Observable<VehicleProfile> {
    return this.http.get<VehicleProfile>(`/selfcare/vehicles/${vehicleId}`);
  }
  
  uploadDocument(vehicleId: string, payload: FormData): Observable<VehicleProfile> {
    return this.http.post<VehicleProfile>(`/selfcare/vehicles/${vehicleId}/documents`, payload)
  }
}
